import { render, staticRenderFns } from "./ProductCategoryAdd.vue?vue&type=template&id=7165c753&"
import script from "./ProductCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports